import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonDropdown, ICommonDropdownOption } from 'pg-ui-library';
import { useActions } from '../../hooks/useActions';

import { useTypedSelector } from '../../hooks/useTypedSelector';
import { ICompany } from '../../interfaces';
import { CompanyBox, CompanyContainerClosed, CompanyContainerOpen } from './styles';

export const CompanySelect: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const { data, loading: companiesLoading } = useTypedSelector(state => state.companies);
  const { config } = useTypedSelector(state => state.config.data);
  const { loading: selectedCompanyLoading } = useTypedSelector(state => state.config);
  const [currentCompany, setCurrentCompany] = useState<ICompany>();

  const { patchConfig } = useActions();
  const [dropdownOptions, setDropdownOptions] = useState<ICommonDropdownOption[]>([]);
  const { t } = useTranslation();

  const defineInitialValue = () => {
    if (config?.selectedCompanyId) {
      const cpn = data.companies.find(company => company.id === config.selectedCompanyId);
      setCurrentCompany(cpn);
    } else {
      const cpn = data.companies[0];
      setCurrentCompany(cpn);
    }
  };

  const mountDropdownOptions = useCallback(() => {
    const cpnsOptions = data.companies.map((item: ICompany) => ({
      key: item.id,
      label: item.name,
      value: item.legalEntityId,
    }));
    setDropdownOptions(cpnsOptions);
  }, [data.companies]);

  useEffect(() => {
    if (data.companies.length) {
      mountDropdownOptions();
    }
  }, [data.companies.length]);

  useEffect(() => {
    if (data.companies.length) {
      defineInitialValue();
    }
  }, [config?.selectedCompanyId, data.companies.length]);

  const selectCompany = (legalEntityId: string) => {
    const cpn = data.companies.filter((item: ICompany) => item.legalEntityId === legalEntityId)[0];
    patchConfig({ ...config, selectedCompanyId: cpn.id });
    setCurrentCompany(cpn);
  };

  if (companiesLoading || selectedCompanyLoading) {
    return <div />;
  }

  if (!isOpen) {
    return (
      <CompanyBox>
        <span style={{ color: '#f5f5f5', visibility: 'hidden' }}>{t('company.component.title')}</span>
        <CompanyContainerClosed>
          <span>{currentCompany?.legalEntityId}</span>
        </CompanyContainerClosed>
      </CompanyBox>
    );
  }

  return (
    <CompanyBox>
      <span style={{ color: '#f5f5f5' }}>{t('company.component.title')}</span>
      <CompanyContainerOpen>
        <CommonDropdown
          label=""
          id="company"
          name="company"
          setValue={(value: string) => {
            selectCompany(value);
          }}
          value={currentCompany?.legalEntityId}
          options={dropdownOptions}
          wrapperStyle={{ width: '100%' }}
          selectStyle={{
            maxWidth: 'none',
            width: '100%',
            backgroundColor: '#ffffff',
            height: '35px',
          }}
        />
      </CompanyContainerOpen>
    </CompanyBox>
  );
};
